import React, { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import InscricaoEntity from 'entity/Inscricao'
import DefaultCrudForm from 'components/form/DefaultCrudForm'
import DropDownButton from 'components/DropDownButton'
import { useUrlQueryUid2Field } from 'components/form'
import FormRow from 'components/form/FormRow'

import Reuniao from 'entity/Reuniao'
import Rodada from 'entity/Rodada'

import {
    formatDuration as formatDurationI,
    intervalToDuration,
} from "date-fns"
import { dateHoraToStringIso, formatHoraDataLocal, } from 'util/date'
import pt from 'date-fns/locale/pt-BR'

import _ from 'lodash'
import "./style.css"
import AudioDialog from './AudioDialog'

import {
    Box,
    CircularProgress,
    IconButton,
    MenuItem,
    Tooltip,
    Typography
} from '@mui/material'
import Divider from '@mui/material/Divider'
import { Edit } from '@mui/icons-material'
import { useIsAdmin,  useUserUid } from 'useAuth'

// add na url para teste "&teste=2024-09-03T07:55:00"
//  var testStarDate = "2022-10-03T08:59:00"
const velocidadeTeste = 5// x Veses
// var testStarDate = null;
const HeaderReuniões = () => {
    let corUsar = "rgba(255, 255, 255, 0.3)"

    return <Box sx={{ backgroundColor: corUsar, boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)', width: 600, display: 'flex', flex: 1, gap: 2, p: 1, m: 1 }}>
        {/* <div style={{ width: 150, display: "flex", justifyContent: "center" }}>
          
            <Typography variant='h6'>
                {"Horário"}
            </Typography>
        </div>

        <Divider orientation="vertical" flexItem /> */}

        <div style={{ flex: 1, display: "flex", justifyContent: "center" }}>
            {/* <Typography variant='caption'>Mesa</Typography> */}
            <Typography variant='h6'>
                {"Mesa"}
            </Typography>
        </div>

        <Divider orientation="vertical" flexItem />

        <div style={{ flex: 2, display: "flex", justifyContent: "center" }}>
            {/* <Typography variant='caption'>Participante 1</Typography> */}
            <Typography variant='h6'>
                {"Participante 1"}
            </Typography>
        </div>

        <Divider orientation="vertical" flexItem />

        <div style={{ flex: 2, display: "flex", justifyContent: "center" }}>
            {/* <Typography variant='caption'>Participante 2</Typography> */}
            <Typography variant='h6'>
                {"Participante 2"}
            </Typography>
        </div>
        <div style={{ width: 35, display: "flex", alignItems: "center", }}>

        </div>

    </Box>
}
// const limitaCaracter = (nome, limit) => {
//     return nome.slice(0, limit)
// }

const CardReuniao = ({ reuniao, proximaTroca, proximaTroca2, index }) => {
    let corUsar
    // let status

    // if (reuniao.inscricao2.statusEvento === "SAIU"
    //     || reuniao.inscricao1.statusEvento === "SAIU"
    // ) {
    //     corUsar = "rgba(222, 241, 48, 0.7)"
    // } else 
    if (proximaTroca === reuniao.horario.horario) { // PROXIMA

        if (index % 2) {
            corUsar = "rgba(255, 241, 0, 0.66)"
            // corUsar = "rgba(6, 99, 255 ,0.66)"
        } else {
            corUsar = "rgba(250, 240, 77, 0.5)"
            // corUsar = "rgba(92, 153, 255, 0.5)"
        }


        // if (index % 2) {
        //     corUsar = "rgba(89, 255, 186, 0.66)"
        // } else {
        //     corUsar = "rgba(153, 255, 205, 0.5)"
        // }


    } else if (proximaTroca > reuniao.horario.horario) { // AGORA

        if (index % 2) {
            corUsar = "rgba(89, 255, 186, 0.66)"
        } else {
            corUsar = "rgba(153, 255, 205, 0.5)"
        }

        // if (index % 2) {
        //     corUsar = "rgba(6, 99, 255 ,0.66)"
        // } else {
        //     corUsar = "rgba(92, 153, 255, 0.5)"
        // }

        // status = "Em Andamento"
    } else if (proximaTroca2 === reuniao.horario.horario) { // TERCEIRA COLUNA

        if (index % 2) {
            corUsar = "rgba(6, 99, 255 ,0.66)"
        } else {
            corUsar = "rgba(92, 153, 255, 0.5)"
        }
    } else {
        corUsar = "rgba(255, 255, 255, 0.3)"
        // status = ""
    }

    return <Box className='hoverStart' sx={{ backgroundColor: corUsar, boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)', width: 600, display: 'flex', flex: 1, gap: 2, p: 1, m: 1 }}>
        {/* <div style={{ width: 150 }}>
            <div style={{ width: 150, display: "flex", justifyContent: "center" }}>
                <Typography
                    variant='caption'
                >
                    {status
                        ? " (" + status + ")"
                        : ""
                    }
                </Typography>
            </div>
            <div style={{ width: 150, display: "flex", justifyContent: "center" }}>
                <Typography variant='h6'>
                    {reuniao.horariotxt}
                </Typography>
            </div>

        </div> */}

        {/* <Divider orientation="vertical" flexItem /> */}

        <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
            <Typography variant='h6' sx={{ textAlign: "center" }}>
                {/* {reuniao.mesa.index
                    ? "MESA " + (reuniao.mesa.index)// + " - "
                    : `MESA ${(reuniao.rodada.mesas.map(m => m.uid)).indexOf(reuniao.mesa.uid) + 1}`// - `
                } */}
                {reuniao.mesa.name}
            </Typography>
        </div>

        <Divider orientation="vertical" flexItem />

        <div style={{ flex: 2, display: "flex", alignItems: "center", }}>
            <Typography variant='h6' >{`${reuniao.inscricao1.empresa.nomeEmpresaCracha}`}</Typography>
        </div>

        <Divider orientation="vertical" flexItem />

        <div style={{ flex: 2, display: "flex", alignItems: "center", }}>
            <Typography variant='h6'>{`${reuniao.inscricao2.empresa.nomeEmpresaCracha}`}</Typography>
        </div>

        <div className='showHover' style={{ width: 35, display: "flex", alignItems: "center", }}>
            <Tooltip title="EDITAR">
                <IconButton onClick={() => {
                    window.open(`/#/reuniao?uid=${reuniao.uid}`, '_blank')
                    // navigate("/reuniao?uid=" + reuniao.uid)
                }}><Edit /></IconButton>
            </Tooltip>
        </div>
    </Box >
}

const CardHorarioR = ({ valueCard, label = "Agora", hora, reunioes, proximaTroca, proximaTroca2, rodada }) => {

    if (valueCard.intervalo) {
        return <Box sx={{ backgroundColor: '#ccc', boxShadow: '0 4px 8px 0 rgba(0,0,0,0.2)', width: 600, display: 'flex', flex: 1, gap: 2, p: 1, m: 1 }}>
            <div>
                <div style={{}}>

                    <Typography variant='h3'>
                        <b>{valueCard.intervalo.obs}</b>
                    </Typography>
                    <Typography variant='h5'>
                        <b>Das: {hora} ás {formatHoraDataLocal(valueCard.intervalo.fim)}</b>
                    </Typography>

                </div>
            </div>
        </Box>
    }

    return <Box sx={{ display: "flex", flex: 1 }}>
        <div>
            <div style={{}}>
                <Typography variant='caption'>
                    {label}
                </Typography>
                <Typography variant='h3'>
                    <b>{hora}</b>
                </Typography>
            </div>

            <HeaderReuniões />

            {reunioes.length
                ? reunioes.map((r, i) => {
                    return (
                        <CardReuniao
                            reuniao={r}
                            key={i}
                            index={i}
                            proximaTroca={proximaTroca}
                            proximaTroca2={proximaTroca2}
                            rodada={rodada}
                        />
                    )
                })
                : <Typography
                    sx={{ display: "flex", justifyContent: 'center', color: 'text.disabled', paddingTop: "1.5em" }}
                    variant="h6"
                >
                    - NENHUMA REUNIÃO AGORA -
                </Typography>
            }
        </div>
    </Box>
}

function DashboardReuniaoNowInter(props) {
    // add na url para teste "&teste=2022-10-03T08:59:00"
    const { rodada } = props.values
    const [searchParams] = useSearchParams()
    let testeK = searchParams.get("teste")



    const [now, setNow] = useState(testeK)
    const [horaRefReunioes, setHoraRefReunioes] = useState()
    const [tipoConter, setTipoConter] = useState("")
    const [tempoProxima, setTempoProxima] = useState(null)
    const [inscricoes, setInscricoes] = useState(null)
    const [uidInscrPresentes, setUidInscrPresentes] = useState([])
    const [reunioes, setReunioes] = useState(null)
    const [timerColor, setTimerColor] = useState("#000")
    // const [nestReunioes, setNestReunioes] = useState([])
    const [mapHorarios, setMapHorarios] = useState([])
    const [proximaTroca, setProximaTroca] = useState(null)
    const [proximaTroca2, setProximaTroca2] = useState(null)
    const [horarioReuniaoAtual, setHorarioReuniaoAtual] = useState(null)

    const navigate = useNavigate();
    useUrlQueryUid2Field('rodada', 'rodada', Rodada, props.form)
    const uidRodada = rodada?.uid
    const [counter, setCounter] = React.useState(0);
    const [openAudioDialog, setOpenAudioDialog] = useState(true)

    const isAdmin = useIsAdmin()

    const currentUserUID = useUserUid()

    useEffect(() => {
        let observer = null

        if (uidRodada) {
            observer = Rodada.collection.doc(uidRodada).onSnapshot(uidRodada, (snap) => {
                props.form.change('rodada.perfisAutorizado', snap.data().perfisAutorizado)
            })
        }
        return () => {
            if (observer) observer()
        }
    }, [props, uidRodada])

    useEffect(() => {
        if (!horaRefReunioes) {
            let now = new Date()
            setNow(now)
            setHoraRefReunioes(old => {
                let v = dateHoraToStringIso(now)
                if (v !== old) {
                    return v
                } else {
                    return old
                }
            })
        }


    }, [horaRefReunioes])

    //teste timer acelerado
    React.useEffect(() => {
        if (testeK) {
            if (counter > 59) {
                let newD = new Date()
                newD.setMinutes(newD.getMinutes() + 1)
                newD.setSeconds(0)
                setNow(newD)
                setHoraRefReunioes(old => {
                    let v = dateHoraToStringIso(newD)
                    if (v !== old) {
                        return v
                    } else {
                        return old
                    }
                })
                setCounter(0)

            } else {
                setTimeout(() => setCounter(old => old + 1), (1000 / velocidadeTeste));
                let newD = new Date()
                newD.setSeconds(counter)
                setNow(newD)
                setHoraRefReunioes(old => {
                    let v = dateHoraToStringIso(newD)
                    if (v !== old) {
                        return v
                    } else {
                        return old
                    }
                })
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [counter, testeK]);


    useEffect(() => {
        if (now) {
            // let sub = parseInt(rodada.intervaloReuniao) //+ parseInt(rodada.tempoReuniao)

            let d1 = new Date(proximaTroca)
            let d2 = new Date(horarioReuniaoAtual)
            if (horarioReuniaoAtual) {
                d2.setMinutes(d2.getMinutes() + parseInt(rodada.tempoReuniao))
            }
            if (horarioReuniaoAtual && now <= d2) {
                let duration = intervalToDuration({ start: now, end: d2 })
                setTempoProxima(duration)
                setTipoConter("Em Reunião")
                setTimerColor("#000")
            } else if (now <= d1) {
                let duration = intervalToDuration({ start: now, end: d1 })
                setTempoProxima(duration)
                setTipoConter("Intervalo")
                if (horarioReuniaoAtual) {

                    setTimerColor("#00f")
                } else {

                    setTimerColor("#000")
                }
            } else {
                setTipoConter("Em Reunião")
                setTimerColor("#000")
            }
        }



        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [now, proximaTroca, horarioReuniaoAtual])

    useEffect(() => {
        function refreshTime() {
            if (!testeK) {
                let now = new Date()
                setNow(now)
                setHoraRefReunioes(old => {
                    let v = dateHoraToStringIso(now)
                    if (v !== old) {
                        return v
                    } else {
                        return old
                    }
                })

            }
        }

        setInterval(refreshTime, 1000);

        return () => {
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])




    const formatDuration = (duration) => {

        if (!duration) {
            return "00:00"
        }
        if (duration.days) {
            return formatDurationI(duration, {
                delimiter: ', ',
                locale: pt
            },)
        }

        let formatted = ""
        if (duration.hours) {
            formatted += `${duration.hours > 9 ? duration.hours : "0" + duration.hours}:`
        }

        formatted += `${duration.minutes > 9 ? duration.minutes : "0" + duration.minutes}:${duration.seconds > 9 ? duration.seconds : "0" + duration.seconds} `

        return formatted

    }
    useEffect(() => {
        // console.log('horaRefReunioes', horaRefReunioes)
        // console.log('reunioes', reunioes)
        if (horaRefReunioes && reunioes) {

            let horaRefMantemAtual = horaRefReunioes
            let dt = new Date(horaRefMantemAtual)
            // let sub = parseInt(rodada.intervaloReuniao) + parseInt(rodada.tempoReuniao)
            let sub = parseInt(rodada.tempoReuniao)
            dt.setMinutes(dt.getMinutes() - (sub - 1))
            dt.setSeconds(59)
            horaRefMantemAtual = dateHoraToStringIso(dt)
            let copyReunioes = reunioes.slice()
            let mimHora = null
            let mimHora2 = null
            let mapHorariosn = []
            // console.log('uidInscrPresentes', uidInscrPresentes)
            copyReunioes = reunioes.filter(r => {

                if (r.horario.horario >= horaRefMantemAtual) {
                    if (r.horario.horario > horaRefReunioes) {
                        if (mimHora == null || r.horario.horario < mimHora) {
                            mimHora = r.horario.horario
                        }

                        if ((mimHora2 == null || r.horario.horario < mimHora2) && r.horario.horario > mimHora) {
                            mimHora2 = r.horario.horario
                        }
                    }

                    if (uidInscrPresentes.includes(r.inscricao1.uid) && uidInscrPresentes.includes(r.inscricao2.uid)) {

                        let mapR = mapHorariosn.find(m => m.key === r.horario.horario)

                        if (!mapR) {
                            mapR = { key: r.horario.horario, reunioes: [] }
                            mapR.hora = formatHoraDataLocal(r.horario.horario)
                            mapHorariosn.push(mapR)

                        }

                        mapR.reunioes.push(r)
                        mapR.reunioes.sort((a, b) => a.mesa.index > b.mesa.index ? 1 : -1)

                    }
                    // console.log(' mapR.reunioes', mapR.reunioes)
                    return true
                } else {
                    return false
                }
            })

            console.log('mapHorariosn', mapHorariosn)

            if (rodada.intervalos && rodada.intervalos.length) {
                rodada.intervalos.forEach(i => {
                    let mapR = { key: i.inicio, reunioes: [] }

                    mapR.intervalo = i
                    mapR.hora = formatHoraDataLocal(i.inicio)
                    mapHorariosn.push(mapR)
                })
            }

            mapHorariosn.sort((a, b) => {
                return a.key > b.key ? 1 : -1
            })


            setMapHorarios(old => {
                if (_.isEqual(old, mapHorariosn)) {
                    return old
                } else {
                    return mapHorariosn
                }
            })
            // setNestReunioes(old => {
            //     if (_.isEqual(old, copyReunioes)) {
            //         return old
            //     } else {

            //         return copyReunioes
            //     }
            // })
            let primeiraOuAtual = copyReunioes.length ? copyReunioes[0].horario.horario : ""

            if (new Date(primeiraOuAtual) <= now) {
                setHorarioReuniaoAtual(primeiraOuAtual)
            } else {
                setHorarioReuniaoAtual("")
            }
            setProximaTroca(mimHora)
            setProximaTroca2(mimHora2)
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [horaRefReunioes, reunioes, uidInscrPresentes])


    useEffect(() => {
        let observer = null;
        if (uidRodada) {

            observer = Reuniao.collection
                .where("rodada.uid", "==", uidRodada)
                .where("status", "==", "ATIVO")
                .onSnapshot(snap => {
                    let data = []
                    snap.forEach((doc) => {
                        data.push(doc.data());
                    });
                    data.sort((a, b) => {
                        let aH = a.horariotxt.split("-").reverse().join("");
                        let bH = b.horariotxt.split("-").reverse().join("");
                        if (aH === bH) {
                            return a.mesa?.name > b.mesa?.name ? 1 : -1
                        }

                        return aH > bH ? 1 : -1
                    })

                    setReunioes(data);
                })
        }
        return () => {
            if (observer) observer()
        }
    }, [uidRodada])

    useEffect(() => {
        let observer = null
        if (rodada?.uid) {
            let novasMesas = rodada.mesas
            let novasMesasUid = rodada.mesas.map(m => m.uid)

            observer = InscricaoEntity.collection
                .where("rodada.uid", "==", rodada.uid)
                .where("status", "==", "INSCRITO")
                .onSnapshot(snap => {
                    let resultInscricoes = []
                    snap.forEach((doc) => {
                        let insc = doc.data()
                        if (insc.mesa) {
                            let index = novasMesasUid.indexOf(insc.mesa.uid)
                            insc.mesa = novasMesas[index]
                        }

                        resultInscricoes.push(insc);
                    });
                    setInscricoes(resultInscricoes);


                    setUidInscrPresentes(resultInscricoes.filter(ins => {
                        if (ins.status === "INSCRITO" && (ins.statusEvento === "PRESENTE")) {
                            // console.log('ins', ins)
                            return true;
                        }
                        return false;
                    }).map(i => i.uid))

                })
        }
        return () => {
            if (observer) observer()
        }
    }, [rodada])

    useEffect(() => {
        if (inscricoes && reunioes) {
            console.log('updade incricao')
        }


    }, [inscricoes, reunioes])


    return (
        <>
            {rodada
                ? (isAdmin)
                    || (
                        rodada.perfisAutorizado
                        && Object.keys(rodada.perfisAutorizado).length
                        && _.get(rodada.perfisAutorizado, currentUserUID)
                    )
                    ? <div style={{ width: '100%' }}>
                        <FormRow sx={{ flex: 1, pl: 1, pr: 1 }}>

                            <div style={{ flex: 3, display: "flex" }}>
                                <div>
                                    <Typography variant='caption'>Rodada</Typography>
                                    <Typography variant='h3'><b>{rodada.nome?.toUpperCase()}</b></Typography>
                                </div>

                                <DropDownButton label="">
                                    <MenuItem
                                        onClick={() => {
                                            navigate(`/painel-controle?rodada=${rodada.uid}`)

                                        }}
                                    >
                                        Painel da Rodada
                                    </MenuItem>
                                    <MenuItem onClick={() => setOpenAudioDialog(true)}>
                                        Alerta Sonoro
                                    </MenuItem>
                                </DropDownButton>
                            </div>
                            <div style={{ flex: 1.5 }}>
                            </div>
                            <div style={{
                                flex: 1,
                                alignItems: 'center',
                                justifyContent: 'center',
                                display: 'flex',
                                flexDirection: 'column',
                                boxShadow: '0 4px 8px 0 rgba(0,0,0,0.5)',
                                padding: 10,
                                background: "rgba(217, 255, 255, 0.5)"
                            }}>
                                {horarioReuniaoAtual
                                    ? <Typography variant='caption'>
                                        {tipoConter === "Intervalo"
                                            ? "Próxima Reunião em"
                                            : "Próximo intervalo em"
                                        }
                                    </Typography>
                                    : <Typography variant='caption'>
                                        {"Inicia em:"}
                                    </Typography>
                                }

                                <AudioDialog tempoProxima={tempoProxima} open={openAudioDialog} setOpen={setOpenAudioDialog} tipoConter={tipoConter} />

                                <Typography
                                    color={timerColor}
                                    variant={((tempoProxima && tempoProxima.days)
                                        ? "inherit"
                                        : 'h1'
                                    )}
                                >
                                    <b>{formatDuration(tempoProxima)}</b>
                                </Typography>
                                {horarioReuniaoAtual
                                    && <Typography variant='h6'>
                                        <b>{tipoConter}</b>
                                    </Typography>
                                }
                            </div>

                        </FormRow>
                        {reunioes == null &&
                            <FormRow sx={{ flex: 1, alignItems: 'center', justifyContent: "center" }}>
                                <CircularProgress />
                                <Typography>
                                    Carrengado reuniões...
                                </Typography>
                            </FormRow>
                        }
                        <Box sx={{ display: 'flex', overflow: 'auto', transform: 'rotateX(180deg)', maxWidth: "98vw", mt: 2 }}>
                            <Box sx={{ display: 'flex', transform: 'rotateX(180deg)' }}>


                                {(mapHorarios || []).map((h, i) => <CardHorarioR key={i} label={horarioReuniaoAtual === h.key ? "Agora" : "Próxima"} valueCard={h} hora={h.hora} reunioes={h.reunioes} proximaTroca={proximaTroca} proximaTroca2={proximaTroca2} rodada={rodada} />)}
                            </Box>
                        </Box>
                        {/* {nestReunioes &&
                    <Box sx={{ display: "flex", flex: 1 }}>
                        <div>

                            {nestReunioes.length
                                ? <>
                                    <div style={{}}>
                                        <Typography variant='caption'>
                                            Agora
                                        </Typography>
                                        <Typography variant='h3'>
                                            <b>{formatHoraDataLocal(horaRefReunioes)}</b>
                                        </Typography>
                                    </div>

                                    <HeaderReuniões />

                                    {nestReunioes.filter(rf => proximaTroca > rf.horario.horario).length
                                        ? nestReunioes.filter(rf => proximaTroca > rf.horario.horario).map((r, i) => {
                                            return (
                                                <CardReuniao
                                                    reuniao={r}
                                                    key={i}
                                                    proximaTroca={proximaTroca}
                                                />
                                            )
                                        })
                                        : <Typography
                                            sx={{ display: "flex", justifyContent: 'center', color: 'text.disabled', paddingTop: "1.5em" }}
                                            variant="h6"
                                        >
                                            - NENHUMA REUNIÃO AGORA -
                                        </Typography>
                                    }
                                </>
                                : <></>
                            }

                        </div>

                        <div>


                            {nestReunioes.length
                                ? <>
                                    <div style={{}}>
                                        <Typography variant='caption'>
                                            Proxima Reunião
                                        </Typography>
                                        <Typography variant='h3'>
                                            <b>{formatHoraDataLocal(proximaTroca) || "--:-- - --/--"}</b>
                                        </Typography>
                                    </div>

                                    <HeaderReuniões />

                                    {nestReunioes.filter(rf => proximaTroca === rf.horario.horario).length
                                        ? nestReunioes.filter(rf => proximaTroca === rf.horario.horario || proximaTroca < rf.horario.horario).map((r, i) => {
                                            return (
                                                <CardReuniao
                                                    reuniao={r}
                                                    key={i}
                                                    proximaTroca={proximaTroca}
                                                />
                                            )
                                        })
                                        : <Typography
                                            sx={{ display: "flex", justifyContent: 'center', color: 'text.disabled' }}
                                            variant="h6"
                                        >
                                            - NENHUMA REUNIÃO -
                                        </Typography>
                                    }
                                </>
                                : <></>
                            }


                        </div>
                    </Box>
                } */}
                        <AudioDialog tempoProxima={tempoProxima} open={openAudioDialog} setOpen={setOpenAudioDialog} tipoConter={tipoConter} />
                    </div>
                    : <Typography
                        sx={{ display: "flex", justifyContent: 'center', color: 'text.disabled' }}
                        variant="h6"
                    >
                        - SEM PERMISSÃO PARA ACESSAR ESSA RODADA -
                    </Typography>
                :
                <FormRow>
                    <CircularProgress />
                </FormRow>

            }
        </>
    )
}


export default function DashboardReuniaoNow() {

    return (
        <DefaultCrudForm
            title={"Dashboard - Tempo Real"}
            formActions={{ novoForm: false, salvarForm: false, sairForm: false }}
            contentProps={{ sx: { p: 1 } }}
        >
            {(props) => {
                return <DashboardReuniaoNowInter {...props} />
            }}
        </DefaultCrudForm>
    )
}
